import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Resources() {
  const [articles, setArticles] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    Promise.all([api.get("/articles"), api.get("/faqs")]).then(([a, f]) => {
      setArticles(a.data); setFaqs(f.data);
    });
  }, []);

  return (
    <div data-testid="resources-page">
      <section className="hero-bg py-12">
        <div className="container-x">
          <span className="font-cursive text-2xl text-brand-purple">Patient Resources</span>
          <h1 className="text-4xl sm:text-5xl font-bold">Health knowledge, simplified.</h1>
        </div>
      </section>

      <section className="container-x py-10">
        <h2 className="text-2xl font-bold mb-6 text-brand-purple">Health Articles</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((a) => (
            <article key={a.id} className="card-clean p-6" data-testid={`article-${a.id}`}>
              <div className="text-xs font-semibold text-brand-green uppercase">{a.category}</div>
              <h3 className="font-semibold text-lg mt-1">{a.title}</h3>
              <p className="text-sm text-slate-600 mt-2">{a.summary}</p>
              <details className="mt-3 text-sm text-slate-700"><summary className="cursor-pointer text-brand-purple font-semibold">Read more</summary><p className="mt-2 leading-relaxed">{a.content}</p></details>
            </article>
          ))}
        </div>
      </section>

      <section className="container-x py-10">
        <h2 className="text-2xl font-bold mb-6 text-brand-purple">Frequently Asked Questions</h2>
        <div className="space-y-3 max-w-3xl">
          {faqs.map((f) => (
            <div key={f.id} className="card-clean" data-testid={`faq-${f.id}`}>
              <button onClick={() => setOpen(open === f.id ? null : f.id)} className="w-full text-left p-5 flex justify-between gap-3 font-semibold">
                <span>{f.question}</span><span className="text-brand-purple">{open === f.id ? "−" : "+"}</span>
              </button>
              {open === f.id && <div className="px-5 pb-5 text-slate-600 text-sm">{f.answer}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
